"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const UserMenu_1 = __importDefault(require("./UserMenu"));
const react_i18next_1 = require("react-i18next");
exports.default = (0, react_i18next_1.withTranslation)('UserMenu')(UserMenu_1.default);
